<template>
  <div class="PerfectPersonalInfo">
    <img alt="" class="backgro" :src="improvePersonalInfo">
    <div class="phoneNo">
      <span>手机号:</span>
      <input
        v-model="phoneNo"
        type="text"
        placeholder="请输入手机号"
        disabled
      >
    </div>
    <div class="personalName">
      <input v-model="personalName" type="text" placeholder="请输入姓名">
      <span class="identyBtn">身份证识别</span>
      <img alt="" class="identyIcon" :src="identyImg">
      <input
        ref="fileBtn"
        type="file"
        accept="image/*"
        class="input-file"
        mutiple="mutiple"
        @change="handleFile($event)"
      >
    </div>
    <div class="identyNum">
      <input v-model="identyNum" type="text" placeholder="请输入证件号码">
    </div>
    <button class="verification" @click="verification">
      验证
    </button>
    <!-- <p class="tip" v-if="hidshow">温馨提示：企业客户请填写组织机构代码证</p> -->
    <edit-personinfo-dialog :flag="flag" :content="content" :original-phone="originalPhone" @close-dialog="closeDialog"></edit-personinfo-dialog>
    <Loading :switchs="switchs" />
  </div>
</template>
<script>
import api from '@/api/api.js'
import editPersoninfoDialog from "@/components/editPersoninfoDialog/editPersoninfoDialog";
import { motorCodeObj } from '@/utils/const'
import Loading from '@/components/Loadings/Loading'
import checkFormat from '@/utils/checkFormat.js'
export default {
  components: {
    Loading: Loading,
    editPersoninfoDialog
  },
  data() {
    return {
      switchs: false,
      phoneNo: '',
      personalName: '',
      identyNum: '',
      userType: '', // 用户标识
      tipVisible: false, // OCR弹框显示
      showChosenPic: true, // 上传身份证的地方
      imgUrlCamera: '',
      // disabled: false,
      captchaVal: '', // 验证码
      captchaId: '', // 登录验证码ID
      // interval: undefined, //定时器标识
      // totalCount: 0, //60s计时
      imgOriginUrlCamera: api.imgAllUrl + '/sales140709.png',
      improvePersonalInfo: api.imgAllUrl + '/improve Personal Information.png',
      identyImg: api.imgAllUrlZSB + '/gw112702.png',
      showHeight: document.documentElement.clientHeight,
      docmHeight: document.documentElement.clientHeight,
      hidshow: true,
      flag: false,
      content: "",
      originalPhone: "",
      comName: '' // 机构名
    }
  },
  activated() {
    this.$store.commit('set_showStep', false)
  },
  created() {
    document.title = '完善个人信息'
    // this.phoneNo = "18362983759";
    this.phoneNo = this.$route.query.pNum
    // console.log(78, this.$route);
    console.log(motorCodeObj[localStorage.getItem('setMotorCode')])
  },
  mounted() {
    this.switchs = false
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight
        this.showHeight = window.fullHeight
        // console.log("this.showHeight",this.showHeight);
      })()
    }
    const comName = localStorage.getItem('setMotorAreaName')
    this.comName = comName
    localStorage.setItem('setMotorCode',`${this.comName}Code`)
  },
  methods: {
    closeDialog() {
      this.flag = false
    },
    async verification() {
      const reg = /^(?:[\u4e00-\u9fa5]+)(?:·[\u4e00-\u9fa5]+)*$|^[a-zA-Z0-9]+\s?[\.·\-()a-zA-Z]*[a-zA-Z]+$/
      if (this.personalName === '') {
        this.$toast({
          message: '请输入姓名',
          position: 'top',
          duration: 1000
        })
        return false
      } else if (!reg.test(this.personalName)) {
        this.$toast({
          message: '输入的姓名有误，请确认',
          position: 'top',
          duration: 1500
        })
        return false
      } else if (this.identyNum === '') {
        this.$toast({
          message: '请输入证件号码',
          position: 'top',
          duration: 1000
        })
        return false
      } else if (!checkFormat.isCardNo(this.identyNum)) {
        this.$toast({
          message: '您输入的证件号码有误，请重新输入',
          position: 'top',
          duration: 1500
        })
        return false
      }
      this.switchs = true
      let obj = {
        identityNumber: this.identyNum,
        token: localStorage.getItem('setToken')
      }
      // 新增验证规则：用户身份证号是否已绑定其他账号
      const identyNumData = await this.$http
      .post(api.newFindOfficialUserInfo, obj)
      console.log(identyNumData, 'identyNumData')
      if (identyNumData && identyNumData.data) {
        this.switchs = false
        if (identyNumData.data.rtnCode === "0000") {
          if (identyNumData.data.flag) {
            // 身份证已绑定其他手机号
            this.originalPhone = identyNumData.data.phoneNumber
            this.content = `您输入的身份证号已绑定账号${identyNumData.data.phoneNumberEncryption}，直接使用该账户去登录？`
            this.flag = true
            return
          } else {
            console.log("未绑定");
          }
        } else {
          this.$toast(identyNumData.data.rtnMsg || identyNumData.data.status + identyNumData.data.message)
          return
        }
      } else {
        this.switchs = false
        this.$toast("身份证号是否已存在请求失败，请稍后重试或联系管理员")
        return
      }
      function xUdateX(val) {
        var str = val
        var n = str.indexOf('x')
        if (n === 17) {
          val = str.replace('x', 'X')
        }
        return val
      }
      this.identyNum = xUdateX(this.identyNum)
      let sex = parseInt(this.identyNum.substr(16, 1)) % 2 == 1 ? "男" : "女";
      // console.log(sex,'000000000');
      const params = {
        // captchaId: this.$route.query.captchaId, // 验证码ID
        // captchaVal: this.$route.query.captchaVal, // 验证码
        identifyNumber: this.identyNum,
        userName: this.personalName,
        code: "",
        token: localStorage.getItem('setToken'),
        registerFlag: "1" // 用来区别是否根据token校验姓名
        // phoneNumber: this.phoneNo,
        // openId: '',
        // unionId: '',
        // isCheck: '1' // 是否需要验证码（1是0否）
      }
      this.switchs = true
      this.$http
        .post(api.newRegisterForOfficial, params)
        .then((res) => {
          if (res.data.rtnCode === '0000') {
            this.switchs = false
            localStorage.setItem('setToken', res.data.token)
            // console.log(res.data.token, '获取的token')
            this.userType = res.data.userType
            var obj1 = {
              identifyNum: res.data.identifyCode,
              name: res.data.userName,
              phoneNumber: this.phoneNo,
              gender: sex
            };
            localStorage.setItem('cInfo', JSON.stringify(obj1))
            return Promise.resolve(res.data.token)
            // this.$router.push({ name: 'BaseInfo' })

          } else {
            this.switchs = false
            if (res.data.rtnMsg === '该用户尚未登录过') {
              window.location.href = process.env.API_HOST + motorCodeObj[localStorage.getItem('setMotorCode')]
              return false
            }
            this.$toast({
              message: res.data.rtnMsg,
              position: 'top'
            })
            return
          }
        })
        .then((token) => {
          this.switchs = true
          this.$http.get(api.motorPolicy+`/${this.comName}`).then(resTwo => {
            this.switchs = false
            console.log(resTwo, 'motorPolicy')
            if (resTwo.data.rtnCode==='0000') {
              if (resTwo.data.data==null||resTwo.data.data.policyNo == null || resTwo.data.data.policyNo === undefined || resTwo.data.data.policyNo == '') {
                this.$router.push({ name: 'BaseInfo' })
              } else {
                this.$router.push({ name: 'InsuredSuccess', query: {
                  licenseNo: resTwo.data.data.liceseNo,
                  policyNo: resTwo.data.data.policyNo,
                  areaName:this.comName
                }})
              }
            } else {
              Toast(resTwo.data.rtnMsg)
            }
          })
        })
        .catch(err => {
          this.switchs = false
          console.log(err)
          this.$toast({
            message: err,
            position: 'top'
          })
        })
    },
    // OCR
    handleFile(event) {
      const that = this
      const file = event.target.files[0]
      if (!file) return
      // 禁止的格式
      const forbidden = ['html', 'htm', 'svg'];
      const ext = file.name.toLowerCase().split('.').pop();
      if (forbidden.includes(ext)) {
        this.$toast('不支持上传 html/htm/svg 文件！')
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件; // 清空选择
        return
      }
      console.log(this.$refs.fileBtn, 'fileBtn')
      if (this.$refs.fileBtn) {
        this.$refs.fileBtn.value = '' // 避免两次上传相同图片，无法触发change事件
      }
      console.log(file.size)
      that.photoCompress(
        file,
        {
          quality: 0.2
        },
        function(base64Codes) {
          that.showChosenPic = false
          that.imgUrlCamera = base64Codes
          const param = {
            imageInBase64Format: base64Codes,
            systemOrigin: 'OfficialWX',
            businessType: 'OfficialWX-InsuredInfo'
          }
          that.switchs = true
          that.$http
            .post(api.identification_cards, param)
            .then((res) => {
              that.switchs = false
              if (res.data.rtnCode === '0000') {
                that.personalName = res.data.name
                that.identyNum = res.data.idCardNumber
              }
              that.$toast({
                message: '请注意核对自动识别出的信息是否正确',
                position: 'top'
              })
            })
            .catch((error) => {
              that.switchs = false
              console.log(error)
              this.$toast({
                message: error,
                position: 'top'
              })
            })
        }
      )
    },
    photoCompress(file, w, objDiv) {
      const that = this
      var ready = new FileReader()
      /* 开始读取指定的Blob对象或File对象中的内容. 当读取操作完成时,readyState属性的值会成为DONE,如果设置了onloadend事件处理程序,则调用之.同时,result属性中将包含一个data: URL格式的字符串以表示所读取文件的内容.*/
      ready.readAsDataURL(file)
      ready.onload = function(e) {
        that.canvasDataURL(e.target.result, w, objDiv)
      }
    },
    canvasDataURL(path, obj, callback) {
      var img = new Image()
      img.src = path
      img.onload = function() {
        // 默认按比例压缩
        var w = img.width
        var h = img.height
        var scale = w / h
        w = obj.width || w
        h = obj.height || w / scale
        var quality = 0.7 // 默认图片质量为0.7
        // 生成canvas
        var canvas = document.createElement('canvas')
        var ctx = canvas.getContext('2d')
        // 创建属性节点
        var anw = document.createAttribute('width')
        anw.nodeValue = w
        var anh = document.createAttribute('height')
        anh.nodeValue = h
        canvas.setAttributeNode(anw)
        canvas.setAttributeNode(anh)
        ctx.drawImage(img, 0, 0, w, h)
        // 图像质量
        if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
          quality = obj.quality
        }
        // quality值越小，所绘制出的图像越模糊
        var base64 = canvas.toDataURL('image/jpeg', quality)
        // console.log(345, base64);
        // 回调函数返回base64的值
        callback(base64)
      }
    },
    convertBase64UrlToBlob(urlData) {
      var arr = urlData.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      // console.log(356, mime, arr[1] + "00000", bstr);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    hideTipVisible() {
      this.tipVisible = false
      this.$toast({
        message: '请注意核对自动识别出的信息是否正确',
        position: 'top'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./perfectPersonalInfo.scss";
</style>



// WEBPACK FOOTER //
// src/pages/motor/components/motorLogin/components/perfectPersonalInfo/perfectPersonalInfo.vue